import { useIntl } from 'react-intl'
import { useMutation } from 'react-query'

import { QueueCountersAPI } from '@api/queueCountersAPI'

import { Button } from '@components/Button'

import { useAuth } from '@modules/auth/contexts/AuthContext'
import { useQueueMenu } from '@modules/queues/contexts/QueueMenuContext'

import { useAlert } from '@/hooks'
import AxiosUtil from '@/utils/axiosUtil'

const QueueCounterCheckoutButton = () => {
  const intl = useIntl()
  const alert = useAlert()
  const { refetchQueueProcess } = useQueueMenu()
  const { refetchAuth } = useAuth()

  const { mutate: checkoutCounter, isLoading } = useMutation({
    mutationFn: () => QueueCountersAPI.checkOut(),
    onSuccess: () => {
      refetchQueueProcess()
      refetchAuth()

      alert.success({
        text: intl.formatMessage({ id: 'queue.check_out_success' }),
      })
    },
    onError: (err) => {
      if (AxiosUtil.isAxiosError(err)) {
        alert.error({ text: err.response?.data.message })
      } else {
        alert.error({ text: 'Check-out fail, please try again!' })
      }
    },
  })

  const openCheckOutApproveModal = async () => {
    const { isConfirmed } = await alert.question({
      text: intl.formatMessage({ id: 'queue.check_out_text' }),
      confirmButtonText: intl.formatMessage({ id: 'queue.check_out_confirm' }),
    })

    if (isConfirmed) {
      checkoutCounter()
    }
  }

  return (
    <Button
      variant="outline"
      activeTextColor="danger"
      size="sm"
      onClick={openCheckOutApproveModal}
      isLoading={isLoading}
    >
      <i className="fa-solid fa-arrow-right-from-bracket" />
      <span className="ms-1">Check Out</span>
    </Button>
  )
}

export { QueueCounterCheckoutButton }
